import { Box, Heading } from '@hover/blueprint';
import React from 'react';

import { FastLoader } from 'src/modules/designStudio/components/FastLoader';
import { PassiveToastType } from 'src/shared/components/Toast/types';

const PassiveToast = ({ toast }: { toast: PassiveToastType }) => {
  const { title, spinner } = toast;

  return (
    <Box
      backgroundColor="neutral000"
      borderRadius={5}
      id="toast"
      paddingX={400}
      paddingY={200}
      sx={{ boxShadow: ' 0px 2px 4px rgba(0, 36, 69, 0.05)' }}
    >
      <Box alignItems="center" flex={1}>
        {spinner && (
          <FastLoader color="neutral600" marginRight={100} size="small" />
        )}
        <Heading
          color="neutral600"
          margin={0}
          paddingY={200}
          sx={{ fontSize: 14, marginBottom: 0, lineHeight: 0 }}
        >
          {title}
        </Heading>
      </Box>
    </Box>
  );
};

export { PassiveToast };
